import { makeAutoObservable } from 'mobx';
import Cookies from 'js-cookie';
import {AuthResponse}  from "../model/auth-model"


export class SessionUserStore {
    authUser: AuthResponse | null = null;
    token: string | null = null;
    tokenRefresh: string | null = null;
    isAuthenticated: boolean = false;

    // Nom du cookie pour stocker le token
    private readonly COOKIE_NAME = 'MODESSID';
    private readonly COOKIE_NAME_REFRESH = 'MODESSID_REFRESH';

    constructor() {
        makeAutoObservable(this);
        this.initFromCookie();
    }

    private initFromCookie(): void {
        // Récupération du token depuis le cookie
        const token = Cookies.get(this.COOKIE_NAME);
        const refreshToken = Cookies.get(this.COOKIE_NAME_REFRESH);
        if (token && refreshToken) {
            this.token = token;
            this.tokenRefresh = refreshToken;
            this.isAuthenticated = true;
        }
    }

    /**
     * Définir les données utilisateur et le token après connexion
     */
    setSession(userData: AuthResponse): void {
        this.token = userData.token.token;
        this.tokenRefresh = userData.token.refreshToken;
        this.isAuthenticated = true;


        Cookies.set(this.COOKIE_NAME, userData.token.token);
        Cookies.set(this.COOKIE_NAME_REFRESH, userData.token.refreshToken);
    }

    setToken (token: string) {
        this.token = token;
        Cookies.set(this.COOKIE_NAME, token);
    }

    /**
     * Vérifier si l'utilisateur est authentifié
     */
    get isUserAuthenticated(): boolean {
        return this.isAuthenticated && !!this.token;
    }

    /**
     * Obtenir le jeton d'authentification
     */
    getToken(): string | null {
        return this.token;
    }

    /**
     * Obtenir le jeton refresh d'authentification
     */
    getRefreshToken(): string | null {
        return this.tokenRefresh;
    }
}

// Instance singleton du SessionUserStore
const userStore = new SessionUserStore();
export default userStore;